export default class CityDTO {
  constructor(item = {}) {
    this.ID = item.id
    this.label = item.name
  }
}